import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import axios from 'axios';
import { AppilyAuthWelcome, AppilyOverlay } from 'Components/appilyAuth';
import { IRootState } from '@store/root/rootState';

interface Props {
  formTitle: string;
  formSubTitle: string;
  logo: string;
}
const AppilyAuth = ({
  formTitle,
  formSubTitle,
  logo
}: Props) => {
  const [cxRedirectUrl, setCxRedirectUrl] = useState('');
  const [appilyOverlay, setAppilyOverlay] = useState(false);
  const [newTabRef, setNewTabRef] = useState(null);
  const { tourid, locId, cappexId, flexRegId, platform } = useSelector((state: IRootState) => state.tour);
  const { module, source, userkey, sessionId } = useSelector((state: IRootState) => state?.analytics?.analytics);

  const handleContinueButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    // persist client state
    // prepare for appily auth redirect flow
    axios.post(
      `${process.env.REACT_APP_BASE_URL}api/v2/experience/${locId}/tour/${tourid}/appily/session?source=${source}&module_id=${module}&pl=${platform}&userkey=${userkey}&sessionid=${sessionId}`,
      {},
      { withCredentials: true }
    )
    .then((response) => {
      const uuid = response?.data?.resources;
      const flexRegParams = flexRegId?.split('.')
      const redirectUrl = `${process.env.REACT_APP_CAPPEX_URL}/register/${flexRegParams[0]}/${flexRegParams[1]}?tourDataId=${uuid}&tourCollegeId=${cappexId}&tourLocation=${locId}`
      
      // open cappex url in new tab
      const newTab = window.open(redirectUrl, '_blank');
      setNewTabRef(newTab);
      setCxRedirectUrl(redirectUrl)
      setAppilyOverlay(true);
    })
    .catch((error) => {
      console.log('An error has occured');
    });
  }

  useEffect(() => {
    window.addEventListener('message', checkForMessage);
    return () => {
      window.removeEventListener('message', checkForMessage);
    };
  }, [])

  const checkForMessage = (event: any) => {
    if (event.data?.type === 'appily_tab_closed') {
      window.parent.postMessage(
        { message: ':::personalization' },
        '*'
      )
      window.parent.postMessage(
        { message: 'RegistrationForm_Completed', millisecondsUntilClose: 1000 },
        '*'
      );
    }
  }

  // want to check if new tab exists and is not closed before trying to open new tab again
  const handleOverlayContinueClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (newTabRef && !newTabRef.closed) {
      newTabRef.focus();
    } else {
      const newTab = window.open(cxRedirectUrl, '_blank');
      setNewTabRef(newTab);
    }

  }

  return (
    <>
      {appilyOverlay && 
        <AppilyOverlay 
          cxLink={cxRedirectUrl} 
          onCxLinkClick={handleOverlayContinueClick}
          onCloseOverlay={()=> setAppilyOverlay(false)}
        />
      }
      <AppilyAuthWelcome 
        formTitle={formTitle}
        formSubTitle={formSubTitle}
        logo={logo}
        onContinueClick={handleContinueButtonClick}
      />
    </>
  )
}

export default AppilyAuth;try {
    // @ts-ignore
    AppilyAuth.displayName = "AppilyAuth";
    // @ts-ignore
    AppilyAuth.__docgenInfo = { "description": "", "displayName": "AppilyAuth", "props": { "formTitle": { "defaultValue": null, "description": "", "name": "formTitle", "required": true, "type": { "name": "string" } }, "formSubTitle": { "defaultValue": null, "description": "", "name": "formSubTitle", "required": true, "type": { "name": "string" } }, "logo": { "defaultValue": null, "description": "", "name": "logo", "required": true, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/containers/appilyAuth/AppilyAuth.tsx#AppilyAuth"] = { docgenInfo: AppilyAuth.__docgenInfo, name: "AppilyAuth", path: "src/containers/appilyAuth/AppilyAuth.tsx#AppilyAuth" };
}
catch (__react_docgen_typescript_loader_error) { }